/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./submit-confirmation.vue?vue&type=template&id=4e046f40&scoped=true&"
import script from "./submit-confirmation.vue?vue&type=script&lang=js&"
export * from "./submit-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./submit-confirmation.vue?vue&type=style&index=0&id=4e046f40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e046f40",
  null
  
)

export default component.exports